@import "../../../../styles/variables";

.conversational-search-overlay {
  background-color: $svs-black;
  height: 100%;
  left: 50%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  opacity: 0.7;
  width: 100%;
  z-index: 100;
}
